module.exports = __webpack_public_path__ + "static/media/work3.b116ecd8.jpg";